<div class="content-grid-wrapper px-4 pt-4 pb-5">
  <div *ngIf="busy" class="col-md-12 text-center">
    <img src="./assets/images/preloader.gif" />
  </div>
  <div *ngIf="!busy">
    <div>
      <div class="form-wrap">
        <div
          class="form-row form-horizontal"
          *ngFor="let field of options; let i = index"
        >
          <div class="col-sm-4">
            <label>Frequency Type</label>
            <select
              class="form-control"
              [(ngModel)]="field.FrequencyType"
              [disabled]="field.saving"
              (change)="optionChanged(field)"
            >
              <option value="Day">Days</option>
              <option value="Week">Weeks</option>
              <option value="Month">Months</option>
            </select>
          </div>
          <div class="col-sm-4">
            <label>Frequency Value </label>
            <input
              type="number"
              class="form-control"
              [(ngModel)]="field.FrequencyValue"
              [disabled]="field.saving"
              (blur)="optionChanged(field)"
            />
          </div>
          <div class="col-sm-1">
            <p
              class="action-delete"
              (click)="removeField(field)"
              [disabled]="field.saving"
            >
              <i class="fas fa-trash-alt" [hidden]="field.saving"></i>
              <i
                class="fa fa-spinner"
                [hidden]="!field.saving"
                aria-hidden="true"
              ></i>
            </p>
          </div>
          <br />
        </div>
        <button
          type="button"
          (click)="addField()"
          [hidden]="options.length == 3"
          class="btn btn-sml btn-outline"
        >
          <i class="fas fa-plus-circle"></i> Add{{
            options.length > 0 ? " Another" : ""
          }}
        </button>
      </div>
    </div>
  </div>
</div>
